import request from '../index';

export const getLiveList = (languageId = 0, countryId = 0) =>
  request({
    url: `/contents/list/${languageId}/${countryId}`,
  });
